import type { Drama } from "@/types";

export const dramas: Drama[] = [
  {
    id: "xianjian-1",
    title: "仙剑奇侠传",
    year: 2005,
    category: "正传",
    region: "大陆",
    era: "2005-2010",
    rating: 9.1,
    heat: 9980,
    episodes: 38,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20misty%20jade-green%20mountains%20and%20floating%20clouds%2C%20ethereal%20pale%20gold%20light%2C%20elegant%20ancient%20costume%20figure%20with%20sword%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=600&height=800&seq=xj1-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20landscape%20banner%2C%20layered%20jade-green%20mountain%20ranges%20above%20a%20sea%20of%20clouds%2C%20soft%20golden%20sunlight%20rays%2C%20ancient%20immortal%20peak%20with%20pagoda%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=xj1-banner&orientation=landscape",
    tags: ["仙侠", "宿命", "经典", "女娲后人"],
    summary: "跨越人妖仙三界的宿命情缘，少年李逍遥与女娲后人赵灵儿携手踏上传奇仙侠旅程。",
    synopsis: [
      "渔村少年李逍遥在机缘巧合之下结识了落魄千金林月如，并救下了被困的女娲后人赵灵儿。三人因缘际会走到一起，为护送赵灵儿返回南诏国而踏上旅途。",
      "一路上，李逍遥逐渐发现自己与剑圣、酒剑仙之间有着千丝万缕的联系，而赵灵儿背负着女娲一族守护苍生的宿命。情愫在冒险中滋长，三人却不得不面对爱情、牺牲与责任的重重考验。",
      "最终，为了封印水魔兽、拯救苍生，赵灵儿献出了自己的生命。剑起缘灭，只余下那段永不褪色的仙侠传说，成为一代观众心中无法替代的经典。",
    ],
    director: "李国立",
    writer: "邓紫珊",
    cast: ["胡歌", "刘亦菲", "安以轩", "刘品言", "彭于晏"],
    characters: [
      {
        id: "xj1-c1",
        name: "李逍遥",
        actor: "胡歌",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Handsome%20young%20Chinese%20swordsman%20in%20jade-green%20ancient%20robe%2C%20holding%20a%20glowing%20sword%2C%20confident%20smile%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20soft%20golden%20rim%20light%2C%20highly%20detailed&width=500&height=700&seq=xj1-c1&orientation=portrait",
        desc: "余杭镇少年，性格洒脱不羁却重情重义。因救下赵灵儿而卷入仙凡纷争，在磨难中成长为真正的大侠。",
      },
      {
        id: "xj1-c2",
        name: "赵灵儿",
        actor: "刘亦菲",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Gentle%20ethereal%20young%20woman%20with%20long%20black%20hair%20in%20white%20ancient%20dress%2C%20soft%20glowing%20aura%2C%20floating%20petals%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=xj1-c2&orientation=portrait",
        desc: "女娲后人，天真善良、心怀苍生。身负守护三界的宿命，与李逍遥之间有着刻骨铭心的牵绊。",
      },
      {
        id: "xj1-c3",
        name: "林月如",
        actor: "安以轩",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Spirited%20young%20Chinese%20swordswoman%20in%20red%20ancient%20martial%20robe%2C%20holding%20a%20twin%20blade%2C%20fierce%20determined%20expression%2C%20misty%20green%20mountain%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20highly%20detailed&width=500&height=700&seq=xj1-c3&orientation=portrait",
        desc: "林家堡千金，骄纵却痴情。为爱仗剑江湖，敢爱敢恨，是无数观众心中意难平的侠女形象。",
      },
      {
        id: "xj1-c4",
        name: "唐钰",
        actor: "彭于晏",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Young%20Chinese%20warrior%20in%20dark%20green%20ancient%20armor%2C%20carrying%20a%20staff%2C%20loyal%20and%20warm%20expression%2C%20misty%20mountain%20and%20cloud%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj1-c4&orientation=portrait",
        desc: "南诏国勇士，忠义果敢。对赵灵儿一往情深，甘愿默默守护，是团队中可靠而温柔的存在。",
      },
    ],
  },
  {
    id: "xianjian-3",
    title: "仙剑奇侠传三",
    year: 2009,
    category: "正传",
    region: "大陆",
    era: "2005-2010",
    rating: 8.8,
    heat: 9650,
    episodes: 37,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20three%20figures%20silhouetted%20before%20a%20giant%20ancient%20sword%2C%20jade-green%20glow%20and%20pale%20gold%20sparks%2C%20electric%20blue%20lightning%20accent%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20dramatic%20mystical%20atmosphere&width=600&height=800&seq=xj3-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20ancient%20immortal%20temple%20among%20jade-green%20peaks%2C%20glowing%20sword%20of%20light%20piercing%20the%20clouds%2C%20golden%20rays%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=xj3-banner&orientation=landscape",
    tags: ["仙侠", "寻仙", "群像", "轮回"],
    summary: "为寻五灵珠、封印邪剑仙，景天与雪见、徐长卿、紫萱等人联手踏上逆天改命之路。",
    synopsis: [
      "永安当铺小伙计景天，因一枚神秘的玉佩结识了唐家堡大小姐唐雪见，又遇上背负天命的蜀山弟子徐长卿与女娲后人紫萱，四人命运自此纠缠在一起。",
      "为阻止邪剑仙破封而出、危害人间，一行人踏上寻找五灵珠的旅途。在一次次抉择中，他们逐渐明白：真正能颠倒众生的，从来不是仙术，而是人心中的执念与情义。",
      "故事的结局是一曲轮回与牺牲的悲歌。徐长卿与紫萱三生三世的情缘，景天与雪见的相守，都化作了仙侠江湖中久久回响的传说。",
    ],
    director: "李国立",
    writer: "邓紫珊",
    cast: ["胡歌", "杨幂", "霍建华", "唐嫣", "刘诗诗"],
    characters: [
      {
        id: "xj3-c1",
        name: "景天",
        actor: "胡歌",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Playful%20young%20Chinese%20pawnshop%20boy%20in%20simple%20grey-green%20ancient%20clothes%2C%20mischievous%20grin%2C%20holding%20an%20old%20coin%2C%20misty%20mountain%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20warm%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj3-c1&orientation=portrait",
        desc: "永安当铺的小伙计，看似市侩贪财，实则善良重情。因玉佩与仙缘结缘，最终成为拯救苍生的关键人物。",
      },
      {
        id: "xj3-c2",
        name: "唐雪见",
        actor: "杨幂",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Lively%20young%20Chinese%20lady%20in%20pink%20and%20cream%20ancient%20dress%2C%20bright%20mischievous%20smile%2C%20floating%20green%20leaves%2C%20misty%20bamboo%20forest%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj3-c2&orientation=portrait",
        desc: "唐家堡大小姐，古灵精怪、嘴硬心软。与景天是一对欢喜冤家，在嬉笑怒骂中种下深情。",
      },
      {
        id: "xj3-c3",
        name: "徐长卿",
        actor: "霍建华",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Calm%20and%20handsome%20Chinese%20Taoist%20swordsman%20in%20white%20and%20pale%20green%20robe%2C%20holding%20a%20long%20sword%2C%20serene%20expression%2C%20misty%20jade%20mountain%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20cool%20blue%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=xj3-c3&orientation=portrait",
        desc: "蜀山派弟子，清冷克制、心怀苍生。背负师门使命，与紫萱有着三世纠缠的凄美情缘。",
      },
      {
        id: "xj3-c4",
        name: "紫萱",
        actor: "唐嫣",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20with%20long%20purple-black%20hair%20in%20deep%20green%20ancient%20dress%2C%20melancholic%20gaze%2C%20flowing%20silk%20ribbons%2C%20misty%20mountain%20background%2C%20xianxia%20character%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=xj3-c4&orientation=portrait",
        desc: "女娲后人，为爱执着三世。从容温柔又深藏炽烈，是仙剑系列中最令人心碎的痴情女子之一。",
      },
    ],
  },
  {
    id: "xianjian-4",
    title: "仙剑奇侠传四",
    year: 2023,
    category: "正传",
    region: "大陆",
    era: "2011至今",
    rating: 8.2,
    heat: 9120,
    episodes: 36,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20four%20young%20immortal%20disciples%20gathered%20before%20a%20glowing%20moon%20gate%2C%20jade-green%20and%20pale%20gold%20palette%2C%20swirling%20clouds%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20ethereal%20atmosphere&width=600&height=800&seq=xj4-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20sacred%20mountain%20with%20floating%20stone%20platforms%2C%20jade-green%20forest%20below%2C%20glowing%20golden%20runes%20in%20the%20sky%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=xj4-banner&orientation=landscape",
    tags: ["仙侠", "寻仙", "成长", "友情"],
    summary: "云天河与韩菱纱、柳梦璃、慕容紫英因寻仙结缘，一同踏上探寻身世与天道的旅程。",
    synopsis: [
      "云天河自幼在山中长大，与古兽为伴。一次意外让他与盗墓少女韩菱纱相遇，也让他踏出了从未涉足的山林世界。",
      "为了寻找传说中的仙缘与自己的身世之谜，云天河与韩菱纱、柳梦璃、慕容紫英结伴同行。四人性格迥异，却在旅途的磨砺中结下深厚情谊。",
      "当真相逐渐揭开，天河不得不面对人与妖、情与义的抉择。这部作品以细腻的成长叙事，书写了一段关于理想与守护的全新仙剑传奇。",
    ],
    director: "刘海波",
    writer: "白鹤",
    cast: ["鞠婧祎", "陈哲远", "茅子俊", "陈都灵"],
    characters: [
      {
        id: "xj4-c1",
        name: "云天河",
        actor: "陈哲远",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Cheerful%20young%20Chinese%20mountain%20boy%20in%20brown-green%20ancient%20clothes%20with%20a%20large%20bow%2C%20bright%20honest%20smile%2C%20misty%20forest%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20warm%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj4-c1&orientation=portrait",
        desc: "自幼在山中长大的少年，纯真率直、重情重义。对世界充满好奇，也背负着不为人知的身世之谜。",
      },
      {
        id: "xj4-c2",
        name: "韩菱纱",
        actor: "鞠婧祎",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Quick-witted%20young%20Chinese%20girl%20in%20teal%20and%20cream%20ancient%20costume%2C%20playful%20smile%2C%20carrying%20a%20short%20blade%2C%20misty%20green%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj4-c2&orientation=portrait",
        desc: "出身盗墓世家的少女，机灵狡黠、嘴硬心软。与云天河相遇后，一路相伴，是他最可靠的同伴。",
      },
      {
        id: "xj4-c3",
        name: "柳梦璃",
        actor: "陈都灵",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Graceful%20young%20Chinese%20woman%20in%20white%20and%20pale%20jade%20ancient%20dress%2C%20calm%20gentle%20expression%2C%20floating%20petals%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=xj4-c3&orientation=portrait",
        desc: "温婉娴静的大家闺秀，通晓琴艺。看似柔弱，内心却坚韧而通透，是团队中的温柔力量。",
      },
      {
        id: "xj4-c4",
        name: "慕容紫英",
        actor: "茅子俊",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Disciplined%20young%20Chinese%20swordsman%20in%20deep%20green%20and%20gold%20robe%2C%20carrying%20an%20ornate%20sword%2C%20stern%20noble%20expression%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20cool%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xj4-c4&orientation=portrait",
        desc: "琼华派杰出弟子，端方自律、冷静克制。秉持师门信念，却在旅途中逐渐看清真正的天道与人心。",
      },
    ],
  },
  {
    id: "xuanyuanjian-tianzhihen",
    title: "轩辕剑之天之痕",
    year: 2012,
    category: "衍生",
    region: "大陆",
    era: "2011至今",
    rating: 7.9,
    heat: 8210,
    episodes: 40,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20a%20hero%20holding%20a%20glowing%20ancient%20bronze%20sword%20before%20a%20dark%20storm%20sky%2C%20jade-green%20and%20pale%20gold%20lightning%2C%20cinematic%20poster%20illustration%2C%20dramatic%20mystical%20atmosphere%2C%20highly%20detailed&width=600&height=800&seq=xyj-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20ancient%20battlefield%20under%20jade-green%20clouds%2C%20glowing%20golden%20sword%20of%20destiny%20planted%20in%20the%20earth%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20dramatic%20harmonious%20composition&width=1600&height=900&seq=xyj-banner&orientation=landscape",
    tags: ["仙侠", "神器", "宿命", "正邪"],
    summary: "神器轩辕剑现世，一群年轻人被卷入跨越千年的正邪之争与宿命轮回。",
    synopsis: [
      "传说中封印邪念的神器轩辕剑重现人间，平静的世间再度暗流涌动。身负神秘血脉的年轻人被命运选中，卷入了一场关于光明与黑暗的较量。",
      "在追寻真相的路上，主角结识了性格各异的同伴。有人为师门、有人为亲情、有人只为心中那份执着，一路并肩走过刀光剑影与生离死别。",
      "当最后的抉择来临，众人终于明白：真正的力量不在于神器本身，而在于是否愿意为所爱之人直面命运。",
    ],
    director: "李慧珠",
    writer: "钟静",
    cast: ["胡歌", "唐嫣", "蒋劲夫", "刘诗诗", "林更新"],
    characters: [
      {
        id: "xyj-c1",
        name: "陈靖仇",
        actor: "蒋劲夫",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Determined%20young%20Chinese%20martial%20artist%20in%20earth-toned%20ancient%20robe%2C%20holding%20a%20bronze%20sword%2C%20earnest%20expression%2C%20misty%20storm%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=xyj-c1&orientation=portrait",
        desc: "身负灭门之仇的少年侠客，热血正直、重情重义。在复仇与守护之间，逐渐找到自己的道路。",
      },
      {
        id: "xyj-c2",
        name: "宇文拓",
        actor: "胡歌",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Cold%20elegant%20young%20Chinese%20man%20in%20black%20and%20gold%20ancient%20armor%2C%20long%20sword%2C%20piercing%20melancholic%20gaze%2C%20dark%20stormy%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20golden%20accent%20light%2C%20highly%20detailed&width=500&height=700&seq=xyj-c2&orientation=portrait",
        desc: "神秘而强大的剑客，亦正亦邪、深不可测。背负着沉重的过往，为了心中所愿不惜与全世界为敌。",
      },
      {
        id: "xyj-c3",
        name: "独孤宁珂",
        actor: "唐嫣",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Beautiful%20young%20Chinese%20woman%20in%20dark%20emerald%20ancient%20dress%2C%20sharp%20confident%20gaze%2C%20ornate%20jewelry%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=xyj-c3&orientation=portrait",
        desc: "来自异域的冷艳女子，聪明果敢、心思深沉。立场暧昧却自有深情，是故事里最迷人的反角色之一。",
      },
    ],
  },
  {
    id: "gujian-qitan",
    title: "古剑奇谭",
    year: 2014,
    category: "相关仙侠",
    region: "大陆",
    era: "2011至今",
    rating: 8.0,
    heat: 7980,
    episodes: 50,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20a%20lone%20cultivator%20with%20a%20glowing%20jade%20sword%20beneath%20a%20giant%20ancient%20tree%2C%20jade-green%20and%20pale%20gold%20palette%2C%20floating%20leaves%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20mystical%20atmosphere&width=600&height=800&seq=gj-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20vast%20misty%20forest%20with%20a%20giant%20glowing%20sacred%20tree%2C%20jade-green%20tones%20and%20golden%20spirit%20orbs%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=gj-banner&orientation=landscape",
    tags: ["仙侠", "剑灵", "宿命", "古风"],
    summary: "少年百里屠苏身负上古剑灵之力，在追寻身世真相的路上，卷入一场跨越百年的恩怨纠葛。",
    synopsis: [
      "少年百里屠苏天生异禀，身上封印着强大的上古剑灵。为了解开自身的秘密、寻访师门旧事，他踏入江湖，与各路同伴相遇。",
      "旅途中，众人一路追查与神秘法器相关的线索，逐步揭开尘封百年的往事。友情、亲情与爱情在刀光剑影中交织生长。",
      "当宿命的真相水落石出，屠苏必须直面内心的黑暗与执念。这部作品以细腻的人物刻画，勾勒出一幅瑰丽的东方仙侠画卷。",
    ],
    director: "梁胜权",
    writer: "邵潇逸",
    cast: ["李易峰", "杨幂", "乔振宇", "陈伟霆", "迪丽热巴"],
    characters: [
      {
        id: "gj-c1",
        name: "百里屠苏",
        actor: "李易峰",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Cool%20young%20Chinese%20cultivator%20in%20white%20and%20jade-green%20ancient%20robe%2C%20glowing%20sword%20at%20his%20side%2C%20reserved%20determined%20expression%2C%20misty%20forest%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=gj-c1&orientation=portrait",
        desc: "身负上古剑灵之力的少年，外冷内热、坚韧内敛。一生都在与命运抗争，只为守护心中珍视之人。",
      },
      {
        id: "gj-c2",
        name: "风晴雪",
        actor: "杨幂",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Warm%20young%20Chinese%20woman%20in%20cream%20and%20green%20ancient%20dress%2C%20gentle%20smile%2C%20holding%20a%20small%20lantern%2C%20misty%20forest%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=gj-c2&orientation=portrait",
        desc: "温婉善良的少女，医术高明、心怀慈悲。始终坚定地陪伴在屠苏身边，是他最温暖的依靠。",
      },
      {
        id: "gj-c3",
        name: "欧阳少恭",
        actor: "乔振宇",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Elegant%20young%20Chinese%20scholar%20in%20pale%20gold%20and%20green%20ancient%20robe%2C%20holding%20a%20jade%20flute%2C%20enigmatic%20expression%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=gj-c3&orientation=portrait",
        desc: "琴心剑胆的公子，风度翩翩、城府极深。看似温润如玉，实则背负着刻骨的执念与悲情。",
      },
    ],
  },
  {
    id: "huaqiangu",
    title: "花千骨",
    year: 2015,
    category: "相关仙侠",
    region: "大陆",
    era: "2011至今",
    rating: 7.7,
    heat: 8760,
    episodes: 58,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20a%20slender%20girl%20in%20white%20ancient%20dress%20standing%20before%20a%20giant%20ancient%20sword%2C%20jade-green%20and%20pale%20gold%20sparks%2C%20floating%20petals%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20ethereal%20atmosphere&width=600&height=800&seq=hqg-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20immortal%20sect%20perched%20on%20jade-green%20peaks%20surrounded%20by%20clouds%2C%20golden%20light%20rays%20and%20floating%20petals%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=hqg-banner&orientation=landscape",
    tags: ["仙侠", "师徒", "虐恋", "古风"],
    summary: "世间最后一个神花千骨与上仙白子画之间的师徒情缘，一段关于爱与守护的旷世悲歌。",
    synopsis: [
      "少女花千骨为求延命之方，偶遇上仙白子画，并被收为门下弟子。师徒二人在长年相处中，情愫暗生。",
      "然而仙门规矩森严、天劫步步紧逼，花千骨被卷入一场关于命运与劫数的巨大漩涡。她在磨难中逐渐觉醒，也越发坚定地守护所爱。",
      "当一切尘埃落定，那句未曾说出口的深情，化作了仙侠世界里最令人动容的传说。",
    ],
    director: "高林豹",
    writer: "饶俊",
    cast: ["霍建华", "赵丽颖", "蒋欣", "马可", "李纯"],
    characters: [
      {
        id: "hqg-c1",
        name: "花千骨",
        actor: "赵丽颖",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Delicate%20young%20Chinese%20girl%20in%20white%20ancient%20dress%2C%20innocent%20yet%20resolute%20expression%2C%20floating%20petals%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=hqg-c1&orientation=portrait",
        desc: "世间最后一个神，生来命格奇特。天真善良、坚韧执着，为爱甘愿逆天而行，用尽一生守护心中所爱。",
      },
      {
        id: "hqg-c2",
        name: "白子画",
        actor: "霍建华",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Immortal%20Chinese%20man%20in%20white%20and%20pale%20green%20flowing%20robe%2C%20long%20sword%2C%20cold%20serene%20expression%2C%20misty%20cloud%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20cool%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=hqg-c2&orientation=portrait",
        desc: "长留上仙，清冷孤高、心怀天下。表面淡漠，实则情根深种，是无数人心中最难忘的白衣仙人。",
      },
      {
        id: "hqg-c3",
        name: "霓漫天",
        actor: "李纯",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Proud%20young%20Chinese%20woman%20in%20pink%20and%20gold%20ancient%20dress%2C%20sharp%20ambitious%20gaze%2C%20ornate%20hairpin%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20character%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=hqg-c3&orientation=portrait",
        desc: "蓬莱掌门之女，骄纵任性、爱恨分明。因爱生妒，成为推动故事悲剧走向的关键人物。",
      },
    ],
  },
  {
    id: "sansheng-sanshi",
    title: "三生三世十里桃花",
    year: 2017,
    category: "相关仙侠",
    region: "大陆",
    era: "2011至今",
    rating: 7.6,
    heat: 8540,
    episodes: 58,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20an%20immortal%20man%20and%20woman%20in%20flowing%20robes%20beneath%20a%20blooming%20peach%20tree%2C%20jade-green%20and%20pale%20gold%20palette%2C%20falling%20pink%20petals%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20ethereal%20atmosphere&width=600&height=800&seq=ss-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20vast%20jade-green%20immortal%20realm%20with%20endless%20peach%20blossoms%2C%20golden%20mist%20and%20floating%20clouds%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=ss-banner&orientation=landscape",
    tags: ["仙侠", "仙恋", "三世", "唯美"],
    summary: "青丘女君白浅与九重天太子夜华，跨越三生三世的仙凡情缘，唯美而蚀骨。",
    synopsis: [
      "青丘女君白浅因封印擎苍而重伤沉睡，化作凡人。机缘之下，她与九重天太子夜华相遇相恋，却在误会中走向生离死别。",
      "三百年后重逢，前世的记忆与今生的情缘交织。曾经的误会、牺牲与深情，在重逢的瞬间悉数涌回。",
      "这部作品以唯美的东方仙恋叙事，讲述了一段跨越生死与轮回的爱情，也成就了仙侠题材中极具辨识度的经典。",
    ],
    director: "林玉芬",
    writer: "唐七",
    cast: ["杨幂", "赵又廷", "迪丽热巴", "高伟光", "张彬彬"],
    characters: [
      {
        id: "ss-c1",
        name: "白浅",
        actor: "杨幂",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Elegant%20immortal%20Chinese%20woman%20in%20flowing%20white%20and%20jade-green%20dress%2C%20long%20flowing%20hair%2C%20calm%20proud%20expression%2C%20peach%20blossom%20petals%2C%20misty%20cloud%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=ss-c1&orientation=portrait",
        desc: "青丘女君，四海八荒第一绝色。洒脱通透、敢爱敢恨，历经三世仍不改深情与傲骨。",
      },
      {
        id: "ss-c2",
        name: "夜华",
        actor: "赵又廷",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Handsome%20immortal%20Chinese%20man%20in%20black%20and%20gold%20flowing%20robe%2C%20long%20sword%2C%20cold%20devoted%20gaze%2C%20misty%20cloud%20mountain%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=ss-c2&orientation=portrait",
        desc: "九重天太子，冷峻深情、一诺千金。为爱隐忍付出，是三生三世中最痴情的那一抹身影。",
      },
      {
        id: "ss-c3",
        name: "白凤九",
        actor: "迪丽热巴",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Spirited%20young%20immortal%20Chinese%20girl%20in%20red%20and%20cream%20ancient%20dress%2C%20bright%20playful%20smile%2C%20fox%20tail%20hint%2C%20peach%20blossom%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20warm%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=ss-c3&orientation=portrait",
        desc: "青丘小帝姬，活泼灵动、敢爱敢追。与东华帝君的一段情缘，温暖又令人心动。",
      },
    ],
  },
  {
    id: "canglanjue",
    title: "苍兰诀",
    year: 2022,
    category: "相关仙侠",
    region: "大陆",
    era: "2011至今",
    rating: 8.4,
    heat: 8930,
    episodes: 36,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20a%20fierce%20demon%20lord%20and%20a%20gentle%20fairy%20facing%20each%20other%20in%20swirling%20smoke%2C%20jade-green%20and%20pale%20gold%20embers%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20dramatic%20mystical%20atmosphere&width=600&height=800&seq=clj-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20a%20majestic%20demon%20realm%20palace%20among%20jade-green%20dark%20peaks%2C%20glowing%20golden%20runic%20fire%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20dramatic%20harmonious%20composition&width=1600&height=900&seq=clj-banner&orientation=landscape",
    tags: ["仙侠", "魔尊", "甜虐", "幻想"],
    summary: "仙界小兰花误打误撞收服了苍盐海月尊东方青苍，一场跨越仙魔立场的甜虐纠缠就此展开。",
    synopsis: [
      "单纯善良的仙界小兰花，意外收留并唤醒了被封印的苍盐海月尊东方青苍。两人从针锋相对到相互救赎，牵绊越来越深。",
      "为了守护彼此与族人，他们不得不面对仙魔两界的重重危机。东方青苍的桀骜与深情，小兰花的通透与勇敢，成为彼此最大的救赎。",
      "这部作品以明快节奏与鲜活人物，讲述了一个关于选择、成长与深情守护的仙侠故事。",
    ],
    director: "伊峥",
    writer: "九鹭非香",
    cast: ["虞书欣", "王鹤棣", "张凌赫", "徐海乔"],
    characters: [
      {
        id: "clj-c1",
        name: "小兰花",
        actor: "虞书欣",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Gentle%20young%20Chinese%20fairy%20girl%20in%20pale%20green%20and%20cream%20ancient%20dress%2C%20warm%20earnest%20smile%2C%20floating%20light%20orbs%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=clj-c1&orientation=portrait",
        desc: "仙界天真善良的小仙子，看似柔弱却内心坚定。用真诚与勇气，打动了最桀骜不驯的那颗心。",
      },
      {
        id: "clj-c2",
        name: "东方青苍",
        actor: "王鹤棣",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Fierce%20handsome%20demon%20lord%20in%20black%20and%20gold%20ancient%20armor%2C%20glowing%20violet-green%20flames%2C%20arrogant%20intense%20gaze%2C%20dark%20misty%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=clj-c2&orientation=portrait",
        desc: "苍盐海月尊，桀骜不驯、强大狂傲。冷硬外壳之下藏着一往情深，是近年最受喜爱的仙侠男主之一。",
      },
      {
        id: "clj-c3",
        name: "长珩",
        actor: "张凌赫",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Calm%20elegant%20young%20Chinese%20immortal%20man%20in%20white%20and%20pale%20green%20robe%2C%20holding%20a%20jade%20fan%2C%20gentle%20melancholic%20expression%2C%20misty%20cloud%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=clj-c3&orientation=portrait",
        desc: "仙门尊上，温润如玉、克己深情。默默守护所爱之人，是让无数观众意难平的温柔角色。",
      },
    ],
  },
  {
    id: "liuli",
    title: "琉璃",
    year: 2020,
    category: "相关仙侠",
    region: "港台",
    era: "2011至今",
    rating: 7.8,
    heat: 7620,
    episodes: 59,
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20digital%20art%2C%20a%20young%20man%20and%20woman%20in%20flowing%20robes%20surrounded%20by%20glowing%20glass%20shards%2C%20jade-green%20and%20pale%20gold%20palette%2C%20cinematic%20poster%20illustration%2C%20highly%20detailed%2C%20ethereal%20mystical%20atmosphere&width=600&height=800&seq=ll-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20banner%2C%20ancient%20immortal%20clan%20hall%20amid%20jade-green%20peaks%2C%20glowing%20golden%20glass%20lotus%20floating%20in%20the%20air%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20harmonious%20composition&width=1600&height=900&seq=ll-banner&orientation=landscape",
    tags: ["仙侠", "仙恋", "宿命", "唯美"],
    summary: "天生六识残缺的少女褚璇玑与离泽宫弟子禹司凤，历经十世情劫的仙侠情缘。",
    synopsis: [
      "天生六识残缺的少女褚璇玑，因缘结识了离泽宫弟子禹司凤。两人在朝夕相处中渐生情愫，也一步步卷入上古恩怨。",
      "随着前尘往事被揭开，璇玑与司凤发现彼此早已被十世的宿命牵连。今生相守，是对命运最温柔也最坚定的反抗。",
      "作品以细腻的情感与唯美的画面，讲述了一个关于爱与救赎的仙侠故事。",
    ],
    director: "尹涛",
    writer: "十四郎",
    cast: ["成毅", "袁冰妍", "刘学义", "张予曦"],
    characters: [
      {
        id: "ll-c1",
        name: "褚璇玑",
        actor: "袁冰妍",
        role: "女主角",
        image:
          "https://readdy.ai/api/search-image?query=Young%20Chinese%20immortal%20girl%20in%20white%20and%20pale%20jade%20ancient%20dress%2C%20gentle%20resolute%20expression%2C%20glowing%20glass%20petals%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20soft%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=ll-c1&orientation=portrait",
        desc: "天生六识残缺的少女，纯真坚韧、重情重义。在寻回感官与世界的过程中，也找回了自己的命运。",
      },
      {
        id: "ll-c2",
        name: "禹司凤",
        actor: "成毅",
        role: "男主角",
        image:
          "https://readdy.ai/api/search-image?query=Handsome%20young%20Chinese%20immortal%20swordsman%20in%20white%20and%20jade-green%20robe%2C%20long%20sword%2C%20devoted%20gentle%20gaze%2C%20misty%20mountain%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20golden%20light%2C%20highly%20detailed&width=500&height=700&seq=ll-c2&orientation=portrait",
        desc: "离泽宫弟子，清冷隐忍、一往情深。为所爱之人甘愿付出一切，是最令人心动的痴情守护者。",
      },
      {
        id: "ll-c3",
        name: "昊辰",
        actor: "刘学义",
        role: "主要角色",
        image:
          "https://readdy.ai/api/search-image?query=Handsome%20young%20Chinese%20heavenly%20man%20in%20white%20and%20gold%20ancient%20robe%2C%20stern%20noble%20expression%2C%20glowing%20golden%20halo%2C%20misty%20cloud%20background%2C%20xianxia%20fantasy%20portrait%20illustration%2C%20pale%20gold%20light%2C%20highly%20detailed&width=500&height=700&seq=ll-c3&orientation=portrait",
        desc: "天界执掌者，威严深沉、执念深重。在职责与情感之间挣扎，是推动剧情转折的重要角色。",
      },
    ],
  },
];

export const featuredDramaIds = [
  "xianjian-1",
  "xianjian-3",
  "xianjian-4",
  "canglanjue",
  "huaqiangu",
];